module.exports = __webpack_public_path__ + "static/img/tabbar_home_normal@2x.912e1f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tabbar_home_normal@2x.png
// module id = 7Bmu
// module chunks = 1